;(function (angular, _) {
  'use strict'
  angular.module('kilo.routes.dashboard')
    .controller('DashboardToolbarController', DashboardToolbarController)

  DashboardToolbarController.$inject = [
    // Angular
    '$state',
    // Libs
    '$uibModal',
    // Managers
    'DashboardManager',
    // Services
    'CardCreationService', 'DisplayService',
    // Const
    // Resolved
    'currentDashboard', 'dashboards', 'prefs'
  ]

  function DashboardToolbarController (
    // Angular
    $state,
    // Libs
    $uibModal,
    // Managers
    DashboardManager,
    // Services
    CardCreationService, DisplayService,
    // Const
    // Resolved
    currentDashboard, dashboards, prefs
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        // Public Attributes
        dashboards: dashboards,
        current: currentDashboard,
        prefs: prefs,
        // Public Method
        createCard: createCard,
        editDashboard: editDashboard,
        changeDashboard: changeDashboard,
        newDashboard: newDashboard,
        removeDashboard: removeDashboard,
        duplicate: duplicate,
        setAsDefault: setAsDefault,
        isDefaultDashboard: isDefaultDashboard
      })

      init()
    }

    function init () {
      self.shared = _.remove(self.dashboards, function (dashboard) {
        return dashboard.shared
      })
    }

    function setAsDefault () {
      prefs.settings.dashboard.default === currentDashboard._id ? prefs.settings.dashboard.default = dashboards[0]._id : prefs.settings.dashboard.default = currentDashboard._id
      prefs.save()
    }

    function isDefaultDashboard () {
      return prefs.settings.dashboard.default === currentDashboard._id
    }

    function changeDashboard () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/dashboard-change/dashboard-change-modal.template.html',
        controller: 'DashboardChangeModalController',
        controllerAs: 'ctrl',
        resolve: {
          current: function () { return currentDashboard },
          dashboards: function () { return dashboards },
          shared: function () { return self.shared }
        }
      })
    }

    function newDashboard () {
      DashboardManager.create({ label: 'Nouveau Tableau de Bord' })
        .save()
        .then(function (saved) {
          $state.go('dashboard', { current: saved.data._id })
        })
    }

    function removeDashboard () {
      DisplayService.confirmDeletion().then(function () {
        currentDashboard.delete().then(function () {
          $state.reload()
        })
      })
    }

    function editDashboard () {
      $uibModal.open({
        animation: true,
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/dashboard-edit.modal.html',
        controller: 'DashboardEditModalController',
        controllerAs: 'editModal',
        resolve: {
          dashboard: function () { return currentDashboard },
          prefs: [function () {
            return prefs
          }],
          isAdmin: ['SessionService', function (SessionService) {
            return _.includes(SessionService.getRoles(), 'admin')
          }]
        }
      }).result.then(function (dashboard) {
        self.current.save().then(function () {
          dashboard.save('cards')
          $state.reload()
        })
      })
    }

    function createCard () {
      CardCreationService.configureCard().then(function (card) {
        var isNew = !card._id
        card.options = card.options || {}
        card.options.shared = _.get(self.current, 'options.shared', false)
        card.save().then(function () {
          if (isNew) {
            self.current.cards.push(card)
            self.current.save().then(function () {
              $state.reload()
            })
          }
        })
      })
    }

    function duplicate () {
      $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/dashboard/modals/duplicate-dashboard/duplicate-dashboard-modal.template.html',
        resolve: {
          label: [function () {
            return 'Copie de ' + angular.copy(self.current.label)
          }]
        },
        controller: ['label', function (label) {
          var self = this

          self.label = label
        }],
        controllerAs: 'ctrl'
      }).result.then(function (label) {
        self.current.copy(label).then(function (newDashboard) {
          $state.go('dashboard', { current: newDashboard._id })
        })
      })
    }
  }
})(window.angular, window._)
